import type { MaybeRefOrGetter } from 'vue'
import type { SortField, SortOrder } from '~/models/Content/Sort'
import { computed, toValue } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import useSearchHelper from '~/composables/useSearchHelper'
import useContentApi from '~/api/contentApi'

interface Options {
  sortField?: MaybeRefOrGetter<SortField | undefined>
  sortOrder?: MaybeRefOrGetter<SortOrder | undefined>
}

export function useHeaderChildrenQuery(parentLocationId: MaybeRefOrGetter<number | undefined>, { sortField, sortOrder }: Options = {}) {
  const { findContents } = useContentApi()
  const { cardFields } = useSearchHelper()

  return useQuery({
    enabled: computed(() => !!toValue(parentLocationId)),
    queryKey: computed(() => ['header-children', toValue(parentLocationId), toValue(sortField), toValue(sortOrder)]),
    queryFn: () => findContents({
      parentLocationIdCriterion: [toValue(parentLocationId) as number],
      sortField: toValue(sortField),
      sortOrder: toValue(sortOrder),
    }, undefined, 0, ['intro', ...cardFields]),
    staleTime: Infinity,
  })
}
